import { SplittenMengeKorrekturItemResponse } from '@/types/service-response'
import moment from 'moment'

export class ProjectBookingMengen {
  public constructor (
    readonly Selektiert: boolean,
    readonly Zeile: number | null,
    readonly Bezeichnung: string | null,
    readonly SollMenge: string | null, //double
    readonly IstMenge: string | null, //double
    readonly Verfuegbar: string | null, //double
    readonly Bestand: string | null, //double
    readonly InKommissionierung: number | null,
    readonly Gesperrte: number | null,
    readonly Reserviert: string | null, //double
    readonly Bestellt: string | null, //double
    readonly EinheitCode: number,
    readonly SplittErlaubt: boolean,
    readonly Splitten: boolean,
    readonly RestDatum: string | null,
    readonly TerminArt: boolean
  ) {}

  static createFromResponse (responseData: SplittenMengeKorrekturItemResponse[]): Array<ProjectBookingMengen> {
    let result: Array<ProjectBookingMengen> = []
    if (responseData) {
      result = responseData.map((item: SplittenMengeKorrekturItemResponse) => {
        return new ProjectBookingMengen(
          item.Selektiert,
          item.Zeile,
          item.Bezeichnung,
          item.SollMenge !== null ? item.SollMenge.toFixed(3) : null,
          item.IstMenge!== null ? item.IstMenge.toFixed(3) : null,
          item.Verfuegbar !== null ? item.Verfuegbar.toFixed(3) : null,
          item.Bestand !== null ? item.Bestand.toFixed(3) : null,
          item.InKommissionierung,
          item.Gesperrte,
          item.Reserviert !== null ? item.Reserviert.toFixed(3) : null,
          item.Bestellt !== null ? item.Bestellt.toFixed(3) : null,
          item.EinheitCode,
          item.SplittErlaubt,
          item.Splitten,
          item.RestDatum ? moment(item.RestDatum).format('DD.MM.YYYY') : null,
          item.TerminArt
        )
      })
    }
    return result
  }
}
